import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const KPICard = ({
  title,
  value,
  icon,
  color = 'primary.main',
  subtitle,
  trend,
  trendValue,
  format = 'number',
  loading = false
}) => {
  const formatValue = (val) => {
    if (loading) return '...';
    if (!val && val !== 0) return 'N/A';

    switch (format) {
      case 'currency':
        return `$${val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      case 'percent':
        return `${val.toFixed(1)}%`;
      case 'number':
      default:
        return val.toLocaleString('en-US');
    }
  };

  const getTrendColor = () => {
    if (!trend) return 'text.secondary';
    return trend === 'up' ? 'success.main' : 'error.main';
  };

  return (
    <Card
      sx={{
        height: '100%',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4
        }
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box flex={1}>
            <Typography
              color="text.secondary"
              variant="body2"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              component="div"
              fontWeight="bold"
              color={color}
              sx={{ my: 1 }}
            >
              {formatValue(value)}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
            {trend && trendValue !== undefined && (
              <Box display="flex" alignItems="center" mt={1}>
                {trend === 'up' ? (
                  <TrendingUp sx={{ fontSize: 18, color: getTrendColor(), mr: 0.5 }} />
                ) : (
                  <TrendingDown sx={{ fontSize: 18, color: getTrendColor(), mr: 0.5 }} />
                )}
                <Typography variant="body2" color={getTrendColor()} fontWeight="medium">
                  {Math.abs(trendValue).toFixed(1)}%
                </Typography>
                <Typography variant="body2" color="text.secondary" ml={0.5}>
                  vs last period
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: 2,
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {React.cloneElement(icon, {
              sx: { fontSize: 32, color: color }
            })}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default KPICard;
